import { supabase } from '@/integrations/supabase/client';

export interface AIModelConfiguration {
  id?: string;
  website_id: string;
  model_name: string;
  temperature: number;
  max_tokens: number;
  top_p: number;
  frequency_penalty: number;
  presence_penalty: number;
  created_at?: string;
  updated_at?: string;
}

export interface AIModelConfigResponse {
  success: boolean;
  configuration?: AIModelConfiguration | null;
  error?: string;
  message?: string;
}

/**
 * Fetches AI model configuration for a website
 */
export const getAIModelConfiguration = async (websiteId: string): Promise<AIModelConfigResponse> => {
  try {
    const { data, error } = await supabase.functions.invoke('ai-model-config', {
      body: {
        website_id: websiteId,
        action: 'get'
      }
    });

    if (error) {
      console.error('Error fetching AI model configuration:', error);
      return {
        success: false,
        error: error.message || 'Failed to fetch AI model configuration'
      };
    }

    return {
      success: true,
      configuration: data.configuration
    };
  } catch (error) {
    console.error('Error in getAIModelConfiguration:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Failed to fetch AI model configuration'
    };
  }
};

/**
 * Updates AI model configuration for a website
 */
export const updateAIModelConfiguration = async (
  websiteId: string, 
  config: Partial<AIModelConfiguration>
): Promise<AIModelConfigResponse> => {
  try {
    const { data, error } = await supabase.functions.invoke('ai-model-config', {
      body: {
        website_id: websiteId,
        action: 'update',
        ...config
      }
    });

    if (error) {
      console.error('Error updating AI model configuration:', error);
      return {
        success: false,
        error: error.message || 'Failed to update AI model configuration'
      };
    }

    return {
      success: true,
      configuration: data.configuration,
      message: data.message
    };
  } catch (error) {
    console.error('Error in updateAIModelConfiguration:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Failed to update AI model configuration'
    };
  }
};
